interface IProps {
  fillCOlor: string;
  className?: string;
}

export const ArrowRightCarousel = ({ fillCOlor, className }: IProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="21"
      viewBox="0 0 13 21"
      fill="none"
      className={className}
    >
      <path
        d="M12.5571 11.6153L3.99903 20.5375C3.40751 21.1542 2.45102 21.1542 1.86579 20.5375L0.443638 19.0548C-0.147879 18.4381 -0.147879 17.441 0.443638 16.8308L6.50983 10.5066L0.443638 4.18229C-0.147879 3.5656 -0.147879 2.56842 0.443638 1.95829L1.8595 0.462512C2.45102 -0.154171 3.40751 -0.154171 3.99274 0.462512L12.5509 9.38472C13.1487 10.0014 13.1487 10.9986 12.5571 11.6153Z"
        fill={fillCOlor}
      />
    </svg>
  );
};
